import { BasicSemaphore } from './basicSemaphore'
import { getApiInstance } from './getApiInstance'
import { getErrorCooldownTime } from './getErrorCooldownTime'
import type { ApiCache, Call, Client } from './type'
import { UrlsSemaphore } from './urlsSemaphore'

type CreateClient = (urls: string[]) => Client

const ONE_MINUTE = 60 * 1000
const ONE_HOUR = 60 * ONE_MINUTE
const ONE_DAY = 24 * ONE_HOUR

export const createClient: CreateClient = (urls) => {
  const cache: ApiCache = {
    url: undefined,
    api: undefined,
  }
  const createSemaphore = new BasicSemaphore(1)
  const urlsSemaphore = new UrlsSemaphore(urls)

  const call: Call = async (func, timeout = ONE_HOUR) => {
    // cache, semaphoreから Api Instance 取得
    const { api, url } = await getApiInstance({
      cache,
      createSemaphore,
      urlsSemaphore,
      timeout,
    })

    try {
      // apiPromiseを渡してfuncを実行
      const result = await func(api)

      urlsSemaphore.release(url)
      return result
    } catch (error) {
      // エラー時はキャッシュをクリア
      cache.api = undefined
      cache.url = undefined

      // api 切断
      await api.disconnect()

      // error が retry 対象の場合、cooldown 時間を取得
      const cooldown = getErrorCooldownTime(error)
      if (cooldown) {
        // url を cooldown 時間で設定
        urlsSemaphore.release(url, cooldown)
        // retry
        return await call(func, timeout)
      }

      // 未対応 error の場合は cooldown 1日に設定してエラーはそのまま投げる
      urlsSemaphore.release(url, ONE_DAY)
      throw error
    }
  }

  return {
    call,
  }
}
